"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getForumPostDateMutableEnabled = exports.getShowGenderIdentityEnrollmentEnabled = exports.getShowDOBEnrollmentEnabled = exports.getAccessCodeEnrollmentEnabled = exports.getExitInterviewFeatureEnabled = exports.getReferralsFeatureEnabled = exports.getGoalSettingFeatureEnabled = exports.getSurveysFeatureEnabled = exports.getFormsFeatureEnabled = exports.getIncentivesFeatureEnabled = exports.getDefaultAppointmentLength = exports.getAppointmentAvailabilityFeatureEnabled = exports.getAppointmentsFeatureEnabled = exports.getTestKitsFeatureEnabled = exports.isAuthenticating = exports.isAuthenticated = exports.getAdminStatus = exports.deleteAdminUserStatus = exports.updateAdminUserStatus = exports.updateAdminPasswordStatus = exports.deleteAvailabilityStatus = exports.createAvailabilityStatus = exports.deleteGoalStatus = exports.updateGoalStatus = exports.createGoalStatus = exports.getGoalStatus = exports.loadGoalsStatus = exports.getActivityStatus = exports.deleteAppointmentStatus = exports.updateAppointmentStatus = exports.createAppointmentStatus = exports.createMessageThreadStatus = exports.saveArticleStatus = exports.saveForumPostStatus = exports.createUserStatus = exports.updatePasswordStatus = exports.getPaymentsReportStatus = exports.getAnalyticsReportStatus = exports.loadQnaPostsStatus = exports.updateAnnouncementStatus = exports.createAnnouncementStatus = exports.loadAnnouncementsStatus = exports.loadNotesStatus = exports.getMessagesStatus = exports.loadMessageInboxStatus = exports.loadMessagesStatus = exports.loadCommentsStatus = exports.loadResourceTopicsStatus = exports.loadBadgeGroupsStatus = exports.loadBadgesStatus = exports.loadPostsStatus = exports.getRequestedEditResourceStatus = exports.loadRequestedFormsStatus = exports.getStudyPostsLoadingStatus = exports.getUserLoadingStatus = exports.getAvatarLoadingStatus = exports.loadRequestedParticipantStatus = exports.loadParticipantStatus = exports.loadDashboardStatus = exports.loadStudyStatus = exports.loadStudiesStatus = exports.getRequestedStudyParticipantNotes = exports.getRequestedStudyParticipantThreads = exports.getRequestedStudyParticipantComments = exports.getRequestedParticipantExitInterviewPayment = exports.getRequestedParticipantIncentives = exports.getRequestedParticipantUserSurveys = exports.getRequestedParticipantTestkits = exports.getRequestedParticipantNotifications = exports.getRequestedParticipantForms = exports.getRequestedForms = exports.getRequestedStudyParticipantPosts = exports.getRequestedStudyParticipantAvatar = exports.getRequestedStudyParticipantStudyArm = exports.getRequestedStudyParticipant = exports.getRequestedStudyParticipantUsernames = exports.getRequestedStudyParticipantsWithUsernames = exports.getRequestedStudyStudyArms = exports.getRequestedStudyParticipants = exports.getRequestedEditResource = exports.getRequestedStudy = exports.getAuthenticatedUserId = exports.selectOidcUserProfile = exports.selectOidcUser = exports.selectOidc = void 0;

var _ = _interopRequireWildcard(require("lodash"));

var _toArray = _interopRequireDefault(require("lodash/toArray"));

var _normalizr = require("normalizr");

var _reselect = require("reselect");

var _typesafeActions = require("typesafe-actions");

var _analytics = require("./analitycs/analytics.types");

var _announcements = require("./announcements/announcements.types");

var _api = _interopRequireDefault(require("./api/api.selectors"));

var articleSelectors = _interopRequireWildcard(require("./article/article.selectors"));

var _article2 = require("./article/article.types");

var avatarSelectors = _interopRequireWildcard(require("./avatar/avatar.selectors"));

var _avatar2 = require("./avatar/avatar.types");

var _badges = require("./badges/badges.types");

var commentSelectors = _interopRequireWildcard(require("./comments/comments.selectors"));

var _comments2 = require("./comments/comments.types");

var _dashboard = require("./dashboard/dashboard.types");

var _favorites = require("./favorites/favorites.selectors");

var _flags = require("./flags/flags.selectors");

var formSelectors = _interopRequireWildcard(require("./form/form.selectors"));

var _form2 = require("./form/form.types");

var messageSelectors = _interopRequireWildcard(require("./messages/messages.selectors"));

var _messages2 = require("./messages/messages.types");

var noteSelectors = _interopRequireWildcard(require("./notes/notes.selectors"));

var _notes2 = require("./notes/notes.types");

var notificationSelectors = _interopRequireWildcard(require("./notification/notification.selectors"));

var participantSelectors = _interopRequireWildcard(require("./participants/participants.selectors"));

var _participants2 = require("./participants/participants.types");

var paymentSelectors = _interopRequireWildcard(require("./payment/payment.selectors"));

var _payment2 = require("./payment/payment.types");

var _posts = require("./posts/posts.selectors");

var _posts2 = require("./posts/posts.types");

var _qna = require("./qna/qna.types");

var routerSelectors = _interopRequireWildcard(require("./router/router.selectors"));

var _schema = require("./schema");

var studySelectors = _interopRequireWildcard(require("./study/study.selectors"));

var _study2 = require("./study/study.types");

var testkitSelectors = _interopRequireWildcard(require("./testkit/testkit.selectors"));

var _thumbsups = require("./thumbsups/thumbsups.selectors");

var _topic = require("./topics/topic.types");

var _user = require("./user/user.types");

var userSurveySelectors = _interopRequireWildcard(require("./userSurvey/userSurvey.selectors"));

var _appointments = require("./appointments/appointments.types");

var _activities = require("./activities/activities.types");

var _goals = require("./goals/goals.types");

var _FeatureNames = _interopRequireDefault(require("../components/util/FeatureNames"));

var _availability = require("./availabilty/availability.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const selectOidc = state => {
  return state.oidc;
};

exports.selectOidc = selectOidc;
const selectOidcUser = (0, _reselect.createSelector)([selectOidc], oidc => {
  return oidc ? oidc.user : undefined;
});
exports.selectOidcUser = selectOidcUser;
const selectOidcUserProfile = (0, _reselect.createSelector)([selectOidcUser], user => {
  return user ? user.profile : undefined;
});
exports.selectOidcUserProfile = selectOidcUserProfile;
const getAuthenticatedUserId = (0, _reselect.createSelector)([selectOidcUserProfile], profile => {
  return profile ? profile.sub : undefined;
});
exports.getAuthenticatedUserId = getAuthenticatedUserId;
const getRequestedStudy = (0, _reselect.createSelector)([routerSelectors.getRequestedStudyId, studySelectors.selectStudies, studySelectors.selectStudyArms, participantSelectors.selectParticipants], (id, studies, studyArms, participants) => {
  if (id != -1 && studies && studies.allIds && studies.allIds.length > 0) {
    const {
      studies: denormalizedStudies
    } = (0, _normalizr.denormalize)({
      studies: [id]
    }, _schema.entitySchema, {
      studies: studies.byId,
      studyArms: studyArms.byId,
      participants: participants.byId
    });

    if (denormalizedStudies) {
      const studiesArray = (0, _toArray.default)(denormalizedStudies);

      if (studiesArray && studiesArray.length === 1) {
        return studiesArray[0];
      }
    }
  }

  return undefined;
});
exports.getRequestedStudy = getRequestedStudy;
const getRequestedEditResource = (0, _reselect.createSelector)([routerSelectors.getRequestedEditResourceId, articleSelectors.selectArticles], (id, articles) => {
  if (id != -1 && articles && articles.allIds && articles.allIds.length > 0) {
    return articles.byId[id];
  }

  return undefined;
});
exports.getRequestedEditResource = getRequestedEditResource;
const getRequestedStudyParticipants = (0, _reselect.createSelector)([getRequestedStudy, participantSelectors.getParticipants], (study, participants) => {
  if (!study) {
    return [];
  }

  const {
    studyArms
  } = study;

  if (!studyArms || !participants) {
    return [];
  }

  let studyParticipants = [];
  studyParticipants = participants.filter(p => studyArms.map(sa => sa.id).includes(p.studyArmId));
  return studyParticipants;
});
exports.getRequestedStudyParticipants = getRequestedStudyParticipants;
const getRequestedStudyStudyArms = (0, _reselect.createSelector)([getRequestedStudy], study => {
  if (!study) {
    return [];
  }

  const {
    studyArms
  } = study;

  if (!studyArms) {
    return [];
  }

  return studyArms;
});
exports.getRequestedStudyStudyArms = getRequestedStudyStudyArms;
const getRequestedStudyParticipantsWithUsernames = (0, _reselect.createSelector)([getRequestedStudyParticipants], participants => {
  if (!participants) {
    return [];
  }

  let participantsWithUsernames = [];

  for (let i = 0; i < participants.length; i++) {
    if (participants[i].username) {
      participantsWithUsernames.push(participants[i]);
    }
  }

  return participantsWithUsernames;
});
exports.getRequestedStudyParticipantsWithUsernames = getRequestedStudyParticipantsWithUsernames;
const getRequestedStudyParticipantUsernames = (0, _reselect.createSelector)([getRequestedStudyParticipants], participants => {
  return _.sortBy(_.map(participants, 'username'));
});
exports.getRequestedStudyParticipantUsernames = getRequestedStudyParticipantUsernames;
const getRequestedStudyParticipant = (0, _reselect.createSelector)([routerSelectors.getRequestedParticipantId, participantSelectors.getParticipants], (participantId, participants) => {
  var _a;

  if (!participants) {
    return undefined;
  }

  const matchingParticipants = participants.filter(participant => participant.id === participantId);

  if (!matchingParticipants.length) {
    return undefined;
  }

  const requestedParticipant = matchingParticipants[0];
  requestedParticipant.referredParticipants = [];

  _.forEach((_a = requestedParticipant.referredParticipantIds) === null || _a === void 0 ? void 0 : _a.split(','), refId => {
    var _a;

    const referredParticipant = _.find(participants, p => p.id === parseInt(refId));

    if (referredParticipant) {
      (_a = requestedParticipant.referredParticipants) === null || _a === void 0 ? void 0 : _a.push(referredParticipant);
    }
  });

  if (requestedParticipant.referredByParticipantId) {
    requestedParticipant.referredByParticipant = _.find(participants, p => p.id === requestedParticipant.referredByParticipantId);
  }

  return requestedParticipant;
});
exports.getRequestedStudyParticipant = getRequestedStudyParticipant;
const getRequestedStudyParticipantStudyArm = (0, _reselect.createSelector)([getRequestedStudy, getRequestedStudyParticipant], (study, participant) => {
  if (!study || !participant) {
    return undefined;
  }

  const {
    studyArmId
  } = participant;
  const {
    studyArms
  } = study;

  for (let i = 0; i < studyArms.length; i++) {
    if (studyArms[i].id === studyArmId) {
      return studyArms[i];
    }
  }

  return undefined;
});
exports.getRequestedStudyParticipantStudyArm = getRequestedStudyParticipantStudyArm;
const getRequestedStudyParticipantAvatar = (0, _reselect.createSelector)([avatarSelectors.getAvatars, getRequestedStudyParticipant], (avatars, participant) => {
  if (!avatars || !participant) {
    return undefined;
  }

  const {
    avatarId
  } = participant;

  for (let i = 0; i < avatars.length; i++) {
    if (avatars[i].id === avatarId) {
      return avatars[i];
    }
  }

  return undefined;
});
exports.getRequestedStudyParticipantAvatar = getRequestedStudyParticipantAvatar;
const getRequestedStudyParticipantPosts = (0, _reselect.createSelector)([_posts.getPosts, getRequestedStudyParticipant, commentSelectors.getComments, _flags.getFlags, _thumbsups.getThumbsups, _favorites.getFavorites], (posts, participant, comments, flags, thumbsups, favorites) => {
  if (!posts || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const participantPosts = [];

  for (let i = 0; i < posts.length; i++) {
    if (posts[i].createdByParticipantId === id) {
      let decoratedPost = posts[i];

      const postComments = _.filter(comments, c => 'post' === c.type && c.typeId === decoratedPost.id);

      const commentCount = postComments.length;

      const postFlags = _.filter(flags, f => 'post' === f.type && f.typeId === decoratedPost.id);

      const flagCount = postFlags.length;

      const postThumbsups = _.filter(thumbsups, t => 'post' === t.type && t.typeId === decoratedPost.id);

      const thumbsupsCount = postThumbsups.length;

      const postFavorites = _.filter(favorites, f => 'post' === f.type && f.typeId === decoratedPost.id);

      const favoritesCount = postFavorites.length;
      Object.assign(decoratedPost, {
        commentCount,
        flagCount,
        thumbsupsCount,
        favoritesCount
      });
      participantPosts.push(decoratedPost);
    }
  }

  return participantPosts;
});
exports.getRequestedStudyParticipantPosts = getRequestedStudyParticipantPosts;
const getRequestedForms = (0, _reselect.createSelector)([formSelectors.getForms, getRequestedStudy], (forms, study) => {
  if (!forms || !study) {
    return undefined;
  }

  const {
    id
  } = study;
  const requestedForms = [];

  for (let i = 0; i < forms.length; i++) {
    requestedForms.push(forms[i]);
  }

  return requestedForms;
});
exports.getRequestedForms = getRequestedForms;
const getRequestedParticipantForms = (0, _reselect.createSelector)([formSelectors.getForms, getRequestedStudyParticipant], (forms, participant) => {
  if (!forms || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const requestedForms = [];

  for (let i = 0; i < forms.length; i++) {
    if (forms[i].participantId === id) {
      requestedForms.push(forms[i]);
    }
  }

  return requestedForms;
});
exports.getRequestedParticipantForms = getRequestedParticipantForms;
const getRequestedParticipantNotifications = (0, _reselect.createSelector)([notificationSelectors.getNotifications, getRequestedStudyParticipant], (notifications, participant) => {
  if (!notifications || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const requestedNotifications = [];

  for (let i = 0; i < notifications.length; i++) {
    if (notifications[i].participantId === id) {
      requestedNotifications.push(notifications[i]);
    }
  }

  return requestedNotifications;
});
exports.getRequestedParticipantNotifications = getRequestedParticipantNotifications;
const getRequestedParticipantTestkits = (0, _reselect.createSelector)([testkitSelectors.getTestkits, getRequestedStudyParticipant], (testkits, participant) => {
  if (!testkits || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const participantTestkits = [];

  for (let i = 0; i < testkits.length; i++) {
    if (testkits[i].participantId === id) {
      participantTestkits.push(testkits[i]);
    }
  }

  return participantTestkits;
});
exports.getRequestedParticipantTestkits = getRequestedParticipantTestkits;
const getRequestedParticipantUserSurveys = (0, _reselect.createSelector)([userSurveySelectors.getUserSurveys, getRequestedStudyParticipant], (userSurveys, participant) => {
  if (!(userSurveys === null || userSurveys === void 0 ? void 0 : userSurveys.length) || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const requestedUserSurveys = [];

  for (let i = 0; i < userSurveys.length; i++) {
    if (userSurveys[i].participantId === id) {
      requestedUserSurveys.push(userSurveys[i]);
    }
  }

  return requestedUserSurveys;
});
exports.getRequestedParticipantUserSurveys = getRequestedParticipantUserSurveys;
const getRequestedParticipantIncentives = (0, _reselect.createSelector)([paymentSelectors.getPayments, getRequestedStudyParticipant], (payments, participant) => {
  if (!(payments === null || payments === void 0 ? void 0 : payments.length) || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const userPayments = [];

  for (let i = 0; i < payments.length; i++) {
    if (payments[i].participantId === id) {
      userPayments.push(payments[i]);
    }
  }

  return userPayments;
}); //
// export const getRequestedParticipantBadges = createSelector(
//   [getBadges, getRequestedStudyParticipant],
//
//   (badges, participant: Optional<ParticipantType>) => {
//     if (!badges?.length || !participant) {
//       return undefined;
//     }
//
//     const { id } = participant;
//     const userBadges: BadgeType[] = [];
//     for (let i = 0; i < badges.length; i++) {
//       if (badges[i].participantId === id) {
//         userPayments.push(payments[i]);
//       }
//     }
//     return userPayments;
//   }
// );

exports.getRequestedParticipantIncentives = getRequestedParticipantIncentives;
const getRequestedParticipantExitInterviewPayment = (0, _reselect.createSelector)([paymentSelectors.getPayments, getRequestedStudyParticipant], (payments, participant) => {
  if (!(payments === null || payments === void 0 ? void 0 : payments.length) || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;

  const payment = _.find(payments, p => p.incentivePaymentId === 9 && p.participantId === id);

  return payment;
});
exports.getRequestedParticipantExitInterviewPayment = getRequestedParticipantExitInterviewPayment;
const getRequestedStudyParticipantComments = (0, _reselect.createSelector)([commentSelectors.getComments, getRequestedStudyParticipant], (comments, participant) => {
  if (!comments || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const participantComments = [];

  for (let i = 0; i < comments.length; i++) {
    if (comments[i].participantId === id) {
      participantComments.push(comments[i]);
    }
  }

  return participantComments;
});
exports.getRequestedStudyParticipantComments = getRequestedStudyParticipantComments;
const getRequestedStudyParticipantThreads = (0, _reselect.createSelector)([messageSelectors.getMessageThreads, getRequestedStudyParticipant], (threads, participant) => {
  if (!threads || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const participantThreads = [];

  for (let i = 0; i < threads.length; i++) {
    if (threads[i].participantId === id) {
      participantThreads.push(threads[i]);
    }
  }

  return participantThreads;
});
exports.getRequestedStudyParticipantThreads = getRequestedStudyParticipantThreads;
const getRequestedStudyParticipantNotes = (0, _reselect.createSelector)([noteSelectors.getNotes, getRequestedStudyParticipant], (notes, participant) => {
  if (!notes || !participant) {
    return undefined;
  }

  const {
    id
  } = participant;
  const participantNotes = [];

  for (let i = 0; i < notes.length; i++) {
    if (notes[i].participantId === id) {
      participantNotes.push(notes[i]);
    }
  }

  return participantNotes;
});
exports.getRequestedStudyParticipantNotes = getRequestedStudyParticipantNotes;

const getLoadingStatus = (state, type) => {
  const status = (0, _api.default)(state, type);

  if (status) {
    return status;
  }

  return {
    isLoading: false,
    isError: false,
    isSuccess: false
  };
};
/**
 * Since the individual actions catch their own errors, the loadStudies wrapper must check the status of each individual
 * action to determine if the studies are still being loaded or have failed to load.
 *
 * @param state the application state
 */


const loadStudiesStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_study2.loadStudiesAsync.request));
};
/**
 * Since the individual actions catch their own errors, the loadStudy wrapper must check the status of each individual
 * action to determine if the study is still being loaded or has failed to load.
 *
 * @param state the application state
 */


exports.loadStudiesStatus = loadStudiesStatus;

const loadStudyStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_study2.loadStudyAsync.request));
};

exports.loadStudyStatus = loadStudyStatus;

const loadDashboardStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_dashboard.loadDashboardDataAsync.request));
};

exports.loadDashboardStatus = loadDashboardStatus;

const loadParticipantStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_participants2.loadParticipantAsync.request));
};

exports.loadParticipantStatus = loadParticipantStatus;

const loadRequestedParticipantStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_participants2.loadRequestedParticipantAsync.request));
};

exports.loadRequestedParticipantStatus = loadRequestedParticipantStatus;

const getAvatarLoadingStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_avatar2.getAvatarAsync.request));
};

exports.getAvatarLoadingStatus = getAvatarLoadingStatus;

const getUserLoadingStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_user.getUserAsync.request));
};

exports.getUserLoadingStatus = getUserLoadingStatus;

const getStudyPostsLoadingStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_posts2.getPostsAsync.request));
};

exports.getStudyPostsLoadingStatus = getStudyPostsLoadingStatus;

const loadRequestedFormsStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_form2.loadRequestedFormsAsync.request));
};

exports.loadRequestedFormsStatus = loadRequestedFormsStatus;

const getRequestedEditResourceStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_article2.getRequestedArticleAsync.request));
};

exports.getRequestedEditResourceStatus = getRequestedEditResourceStatus;

const loadPostsStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_posts2.getPostsAsync.request));
};

exports.loadPostsStatus = loadPostsStatus;

const loadBadgesStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_badges.getBadgeCollectionsAsync.request));
};

exports.loadBadgesStatus = loadBadgesStatus;

const loadBadgeGroupsStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_badges.getBadgeGroupsAsync.request));
};

exports.loadBadgeGroupsStatus = loadBadgeGroupsStatus;

const loadResourceTopicsStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_topic.loadResourceTopicsAsync.request));
};

exports.loadResourceTopicsStatus = loadResourceTopicsStatus;

const loadCommentsStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_comments2.getParticipantCommentsAsync.request));
};

exports.loadCommentsStatus = loadCommentsStatus;

const loadMessagesStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_messages2.getParticipantThreadsAsync.request));
};

exports.loadMessagesStatus = loadMessagesStatus;

const loadMessageInboxStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_messages2.getMessageInboxAsync.request));
};

exports.loadMessageInboxStatus = loadMessageInboxStatus;

const getMessagesStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_messages2.getMessagesAsync.request));
};

exports.getMessagesStatus = getMessagesStatus;

const loadNotesStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_notes2.getParticipantNotesAsync.request));
};

exports.loadNotesStatus = loadNotesStatus;

const loadAnnouncementsStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_announcements.getAnnouncementsAsync.request));
};

exports.loadAnnouncementsStatus = loadAnnouncementsStatus;

const createAnnouncementStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_announcements.createAnnouncementAsync.request));
};

exports.createAnnouncementStatus = createAnnouncementStatus;

const updateAnnouncementStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_announcements.updateAnnouncementAsync.request));
};

exports.updateAnnouncementStatus = updateAnnouncementStatus;

const loadQnaPostsStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_qna.getQnaPostsAsync.request));
};

exports.loadQnaPostsStatus = loadQnaPostsStatus;

const getAnalyticsReportStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_analytics.getAnalyticsReportAsync.request));
};

exports.getAnalyticsReportStatus = getAnalyticsReportStatus;

const getPaymentsReportStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_payment2.getPaymentsReportAsync.request));
};

exports.getPaymentsReportStatus = getPaymentsReportStatus;

const updatePasswordStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_user.updatePasswordAsync.request));
};

exports.updatePasswordStatus = updatePasswordStatus;

const createUserStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_user.createUserAsync.request));
};

exports.createUserStatus = createUserStatus;

const saveForumPostStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_posts2.savePostAsync.request));
};

exports.saveForumPostStatus = saveForumPostStatus;

const saveArticleStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_article2.saveArticleAsync.request));
};

exports.saveArticleStatus = saveArticleStatus;

const createMessageThreadStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_messages2.createThreadAsync.request));
};

exports.createMessageThreadStatus = createMessageThreadStatus;

const createAppointmentStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_appointments.createAppointmentAsync.request));
};

exports.createAppointmentStatus = createAppointmentStatus;

const updateAppointmentStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_appointments.updateAppointmentAsync.request));
};

exports.updateAppointmentStatus = updateAppointmentStatus;

const deleteAppointmentStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_appointments.deleteAppointmentAsync.request));
};

exports.deleteAppointmentStatus = deleteAppointmentStatus;

const getActivityStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_activities.getActivityAsync.request));
};

exports.getActivityStatus = getActivityStatus;

const loadGoalsStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_goals.getGoalsAsync.request));
};

exports.loadGoalsStatus = loadGoalsStatus;

const getGoalStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_goals.getGoalAsync.request));
};

exports.getGoalStatus = getGoalStatus;

const createGoalStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_goals.createGoalAsync.request));
};

exports.createGoalStatus = createGoalStatus;

const updateGoalStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_goals.updateGoalAsync.request));
};

exports.updateGoalStatus = updateGoalStatus;

const deleteGoalStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_goals.deleteGoalAsync.request));
};

exports.deleteGoalStatus = deleteGoalStatus;

const createAvailabilityStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_availability.createAvailabilityAsync.request));
};

exports.createAvailabilityStatus = createAvailabilityStatus;

const deleteAvailabilityStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_availability.deleteAvailabilityAsync.request));
};

exports.deleteAvailabilityStatus = deleteAvailabilityStatus;

const updateAdminPasswordStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_user.updateAdminPasswordAsync.request));
};

exports.updateAdminPasswordStatus = updateAdminPasswordStatus;

const updateAdminUserStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_user.updateAdminUserAsync.request));
};

exports.updateAdminUserStatus = updateAdminUserStatus;

const deleteAdminUserStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_user.deleteAdminUserAsync.request));
};

exports.deleteAdminUserStatus = deleteAdminUserStatus;

const getAdminStatus = state => {
  return getLoadingStatus(state, (0, _typesafeActions.getType)(_user.getAdminAsync.request));
};

exports.getAdminStatus = getAdminStatus;
const isAuthenticated = (0, _reselect.createSelector)([selectOidcUser], user => {
  return user ? !user.expired : false;
});
exports.isAuthenticated = isAuthenticated;
const isAuthenticating = (0, _reselect.createSelector)([selectOidc], oidc => {
  return oidc ? oidc.isLoadingUser : false;
});
exports.isAuthenticating = isAuthenticating;
const getTestKitsFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.TEST_KITS && feature.enabled));
});
exports.getTestKitsFeatureEnabled = getTestKitsFeatureEnabled;
const getAppointmentsFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.APPOINTMENTS && feature.enabled));
});
exports.getAppointmentsFeatureEnabled = getAppointmentsFeatureEnabled;
const getAppointmentAvailabilityFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  const apptFeature = study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.APPOINTMENTS && feature.enabled);
  return apptFeature && apptFeature.meta.availability_on;
});
exports.getAppointmentAvailabilityFeatureEnabled = getAppointmentAvailabilityFeatureEnabled;
const getDefaultAppointmentLength = (0, _reselect.createSelector)([getRequestedStudy, getAppointmentAvailabilityFeatureEnabled], (study, availabilityEnabled) => {
  if (!availabilityEnabled) {
    return undefined;
  }

  const apptFeature = study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.APPOINTMENTS && feature.enabled);
  return apptFeature && parseInt(apptFeature.meta.appointment_length_minutes);
});
exports.getDefaultAppointmentLength = getDefaultAppointmentLength;
const getIncentivesFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.INCENTIVES && feature.enabled));
});
exports.getIncentivesFeatureEnabled = getIncentivesFeatureEnabled;
const getFormsFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.FORMS && feature.enabled));
});
exports.getFormsFeatureEnabled = getFormsFeatureEnabled;
const getSurveysFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.SURVEYS && feature.enabled));
});
exports.getSurveysFeatureEnabled = getSurveysFeatureEnabled;
const getGoalSettingFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.GOAL_SETTING && feature.enabled));
});
exports.getGoalSettingFeatureEnabled = getGoalSettingFeatureEnabled;
const getReferralsFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.PEER_REFERRALS && feature.enabled));
});
exports.getReferralsFeatureEnabled = getReferralsFeatureEnabled;
const getExitInterviewFeatureEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.EXIT_INTERVIEW && feature.enabled));
});
exports.getExitInterviewFeatureEnabled = getExitInterviewFeatureEnabled;
const getAccessCodeEnrollmentEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.ACCESS_CODE_ENROLLMENT && feature.enabled));
});
exports.getAccessCodeEnrollmentEnabled = getAccessCodeEnrollmentEnabled;
const getShowDOBEnrollmentEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.SHOW_DOB && feature.enabled));
});
exports.getShowDOBEnrollmentEnabled = getShowDOBEnrollmentEnabled;
const getShowGenderIdentityEnrollmentEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.SHOW_GENDER_IDENTITY && feature.enabled));
});
exports.getShowGenderIdentityEnrollmentEnabled = getShowGenderIdentityEnrollmentEnabled;
const getForumPostDateMutableEnabled = (0, _reselect.createSelector)([getRequestedStudy], study => {
  return !!(study === null || study === void 0 ? void 0 : study.enabledFeatures.find(feature => feature.feature === _FeatureNames.default.FORUM_POST_PUBLISH_DATE_MUTABLE && feature.enabled));
});
exports.getForumPostDateMutableEnabled = getForumPostDateMutableEnabled;